import { MrfiktivHttpClientProvider } from "../mrfiktiv-http-client.provider";
import { HttpClient } from "../v1/http-client";
import { ActivityLogService as ActivityLogServiceProxy } from "./../v1/ActivityLogService";
import {
  MrfiktivActivityLogControllerFindAllParamsGen,
  MrfiktivCreateActivityLogDtoGen,
  MrfiktivUpdateActivityLogDtoGen
} from "./../v1/data-contracts";

/**
 * Service to communicate with backend.
 */
export class ActivityLogService {
  /**
   * The HttpClient containing the Axios Instance
   */
  client: HttpClient;

  /**
   * The proxy for communicating with backend.
   */
  proxy: ActivityLogServiceProxy;

  /**
   * @class Initialize Service
   */
  constructor(clientProvider: MrfiktivHttpClientProvider) {
    this.client = clientProvider.client();
    this.proxy = new ActivityLogServiceProxy(this.client);
  }

  /**
   * Sets a new proxy based on the client
   *
   * @param clientProvider the client provider
   */
  setProxy(clientProvider: MrfiktivHttpClientProvider) {
    this.client = clientProvider.client();
    this.proxy = new ActivityLogServiceProxy(this.client);
  }

  /**
   * Creates a document.
   *
   * @param data the document dto
   */
  async create(partnerId: string, data: MrfiktivCreateActivityLogDtoGen) {
    return this.proxy.activityLogControllerCreate(partnerId, data).then(value => value.data);
  }

  /**
   * Gets documents by partner.
   *
   * @returns the documents of the partner
   */
  async getAllForPartner(query: MrfiktivActivityLogControllerFindAllParamsGen) {
    return this.proxy.activityLogControllerFindAll(query).then(value => value.data);
  }

  /**
   * Gets documents by report by partner.
   *
   * @param partnerId
   * @param reportId
   * @returns the documents of the partner
   */
  async getAllByReportForPartner(partnerId: string, reportId: string) {
    const query: MrfiktivActivityLogControllerFindAllParamsGen = {
      partnerId: partnerId,
      filter: [
        {
          key: "source.refId",
          operation: "$eq",
          value: reportId
        },
        {
          key: "source.refType",
          operation: "$eq",
          value: "report"
        }
      ]
    };
    return this.proxy.activityLogControllerFindAll(query).then(value => value.data);
  }

  /**
   * Gets one document of the partner.
   *
   * @param id the document id
   * @returns one document of the partner
   */
  async getOneForPartner(partnerId: string, id: string) {
    return this.proxy.activityLogControllerFindOne(partnerId, id).then(value => value.data);
  }

  /**c
   * Removes a document
   *
   * @param partnerId of the partner
   * @param id the document id
   * @returns removed document
   */
  async removeForPartner(partnerId: string, id: string) {
    return this.proxy.activityLogControllerRemove(partnerId, id).then(value => value.data);
  }

  /**
   * Updates a document
   *
   * @param partnerId of the partner
   * @param id of the document
   * @returns updated document of the partner
   */
  async updateForPartner(partnerId: string, id: string, dto: MrfiktivUpdateActivityLogDtoGen) {
    return this.proxy.activityLogControllerUpdate(partnerId, id, dto).then(value => value.data);
  }
}

/**
 * Service to communicate with backend.
 */
export default new ActivityLogService(new MrfiktivHttpClientProvider());
